      /* function loadScript(src) {
        return new Promise(function (resolve, reject) {
            var s;
            s = document.createElement('script');
            s.src = src;
            s.onload = resolve;
            s.onerror = reject;
            document.head.appendChild(s);
        });
      }

      async function load(){
        if (!window.jQuery){
            await loadScript('//www.guardian.in/cdn/shop/t/215/assets/jquery-3.6.3.min.js?v=90911');
        }  
      }
      
      load(); */
  
$(document).ready(function ($) {
  
  var totalPrice;
  var mainProductSKU = $("#mainProductSKU").val();
  //enable checkboxes after page load
  $("input[type='checkbox']").prop("disabled", false);
  //if (mainProductSKU == "B4G1999"){
  //  $("input[id='49640962588903']").prop("readonly", true);
  //  $("input[id='49651631653095']").prop("readonly", true);
  //}
  //Scroll to top on page load
  $(window).on("beforeunload", function () {
    $(window).scrollTop(0);
  });

  //Show/Hide header tabs
  $(".tab").click(function () {
    $(".tab-content").removeClass("active-tab-content");
    $(".tab-content[data-id='" + $(this).attr("data-id") + "']").addClass(
      "active-tab-content"
    );
    $(".tab").removeClass("active-tab");
    $(this).parent().find(".tab").addClass("active-tab");
    $("#searchbar").val("").trigger("keyup"); //clear search
    //scroll up to top on switching tabs
    $("html, body").animate({ scrollTop: 0 }, 500, "swing");
  });

  //Sticky header on-scroll
  $(window).scroll(function (event) {
   var height = window.innerHeight * 0.3;
    var scroll = $(window).scrollTop();
    if (scroll > height) {
      $(".sticky-header").addClass("show");
    } else {
      $(".sticky-header").removeClass("show");
    }
  });

  //Passing line-items on clicking submit button
  $("#submit-btn").click(function () {
     $(this).find(".button__loading").addClass("active");
    let items = 1;
    $("#flexi-box-form")
      .find(":input:checked")
      .each(function () {
        if ($(this).val() == "No") {
          $(this).prop("disabled", true);
        } else {
          $(this).attr("name", "properties[_ITEM" + items + "]");
          items++;
        }
      });
    $(this).submit();
  });

  //You saved - code starts here
  const selectedPrds = [];
  

  
  let checkboxesSelected = $("input[type='checkbox']");
  checkboxesSelected.each(function (index, checkbox) {
    $(checkbox).on("change", function () {
      if (checkbox.checked) {
        selectedPrds.push({
          price: parseFloat(checkbox.getAttribute("data-price")),
        });
      } else {
        // Remove the product from the array if the checkbox is unchecked.
        const price = parseFloat(checkbox.getAttribute("data-price"));
        const index = selectedPrds.findIndex((item) => item.price === price);
        if (index !== -1) {
          selectedPrds.splice(index, 1);
        }
      }

      totalPrice =
        selectedPrds.reduce((sum, product) => sum + product.price, 0) / 100;
      if (
        $("#flexi-box-form input[type=checkbox]:checked").length ==
        totalproductSelection
      ) {
        const giftPriceText = $("#gift_price").text();
        const numericValue = parseInt(giftPriceText.replace(/\D/g, ""), 10);
        const newSavedValue = totalPrice - numericValue;
        const percentageDiscount = (newSavedValue / totalPrice) * 100;

        $("#you_save_amt").text("₹" + totalPrice + "/-");
        $(".you_save").text("Saved ₹" + newSavedValue);
        $(".your_saved_percentage").text(
          "-" + Math.floor(percentageDiscount) + "%"
        );
      } else {
        $("#you_save_amt").text("₹ X,XXX/-");
        $(".you_save, .your_saved_percentage").empty();
      }
    });
  });
  //You save code ends here

  const totalTabs = $(".tab").length;
  let selectedProducts = {};
  let checkboxes = $("input[type='checkbox']");

  checkboxes.click(function () {
    let currProduct = $(this).attr("data-id");
    let currProductSKU = $(this).attr("data-variant-sku");
    let currProductDataId = $(this).attr("data-id-products");
    let nextTab = null;
    let action = true; // Add or Remove item
    let currTabId = Number(currProductDataId.split("_")[1]);
    let selectionLimit = $('.tab-content[data-id="tab' + currTabId + '"]').attr(
      "data-product-limit"
    );

    $(this).parents(".product-info").find(".added_to_cart").addClass("_hidden");
    $(this)
      .parents(".product-info")
      .find(".product_counter")
      .addClass("_hidden");
    if ($(this).is(":checked")) {
      $(this)
        .parents(".product-info")
        .find(".added_to_cart")
        .removeClass("_hidden");
      $(this)
        .parents(".product-info")
        .find(".product_counter")
        .removeClass("_hidden");
      let productTitle = $(this).val().split("(SKU:")[0];

      /*productTitle = productTitle.split("-");
      delete productTitle["0"];
      delete productTitle["1"];
      productTitle = productTitle.join("-").replace("--", "");*/

      $(".Message_Bar").removeClass("is-hidden");
      $(".Message_Bar p span").text(productTitle);
      setTimeout(function () {
        $(".Message_Bar").addClass("is-hidden");
        $(".Message_Bar p span").text("");
      }, 2500);
    }
    let n = $("[data-id=tab" + currTabId + "] input:checked").length;
    //console.log(currTabId, selectionLimit);
    //console.log(n);
    if (n == selectionLimit) {
        $("[data-id=tab" + currTabId + "] input:not(:checked)").prop("disabled",true);
    } else {
        action = false;
        $("[data-id=tab" + currTabId + "] input:not(:checked)").prop("disabled",false);  
    }

    if (n > selectionLimit) {
      location.reload();
    }

    //Show/Hide bubble counts and tick on completing selection limit
    // if (n == selectionLimit) {
    //   $("#checkbox_count_" + currProductDataId).css("display", "flex");
    //   $("#checkbox_count_" + currProductDataId).html(
    //     `<i class="fa-solid fa-check"></i>`
    //   );
    // } 
    if (n > 0) {
      $("#checkbox_count_" + currProductDataId).css("display", "flex");
      $("#checkbox_count_" + currProductDataId).html(n);
    } else {
      $("#checkbox_count_" + currProductDataId).css("display", "none");
    }

    //Switching tabs after adding mandatory items
    if (action == true) {
      let nextTab = `tab${currTabId + 1}`;
      if ($(`.tab[data-id='${nextTab}']`).length > 0) {
        $(`.tab[data-id='${nextTab}']`).click();
        $("#searchbar").val("").trigger("keyup"); //clear search
        //scroll up to top on switching tabs
        //$("html, body").animate({ scrollTop: 0 }, 500, "swing");
      }
    }

    // Enabling submit btn if all mandatory products are selected
   if (
    $("#flexi-box-form input[type=checkbox]:checked").length == totalproductSelection
  ) {
    $("#submit-btn").removeAttr("disabled"); // Correct jQuery method
  } else {
    $("#submit-btn").attr("disabled", "disabled"); // Correct jQuery method
  }

  
  
    
  });

  /*if (mainProductSKU == "B4G1999") {
    $("input#49651631653095.button").click();
    $("input#49640962588903.button").click();
  }*/

  //Disable inspect element Right click and F12 key
  //$(document).bind("contextmenu", function (e) {
  //e.preventDefault();
  //});
  $(document).keydown(function (e) {
    if (e.which === 123) {
      return false;
    }
  });

  //JS code for custom search bar
  $("#searchbar").on("keyup", function () {
    var value = $(this).val().toLowerCase();
    $("#collection-list li").filter(function () {
      $(this).toggle(
        $(this).find("a").text().toLowerCase().indexOf(value) > -1
      );
    });
  });
  //Clear search on pressing clear button
  $(".search-clear").click(function (e) {
    $("#searchbar").val("").trigger("keyup");
  });


$("#submit-btn").on("submit", function (event) {


      const giftPriceText = $("#gift_price").text();
      const numericValue = parseInt(giftPriceText.replace(/\D/g, ""), 10);
      var idCheck = 1; 
      event.preventDefault();
      var dataType = [];
      //console.log("totalPrice",totalPrice);
      var byodPrice = 0;
      $('#mainProductSKU').append('<input type="hidden" name="properties[_bundle_product'+idCheck+']" value="'+$("#mainProductSKU").val()+'/0/1" />');
      $(".add-to-box .button:checked").each(function () {
        byodPrice = (parseFloat(byodPrice) + parseFloat((($(this).attr("data-price")/100)*numericValue)/totalPrice)).toFixed(2);
        var data = {}; // Create a new object for each iteration
        idData = (new Date().valueOf()).toString() + idCheck.toString();
        data["id"] = parseInt(idData);
        data["quantity"] = 1;
        data["variant_title"] = $(this).attr("data-variant-title");
        data["origin_location"] = "";
        data["fulfillment_status"] = "";
        
        data["gift_card"] = false;
        data["requires_shipping"] = "";
        data["total_discount_set"] = "";
        data["title"] = $(this).attr("data-product-name") + " - " + $(this).attr("data-variant-title");
        data["variant_id"] = parseInt($(this).attr("id"));
        data["tax_lines"] = "";
        data["mrp"] = parseFloat($(this).attr("data-price")/100).toFixed(2);
        
        if (byodPrice > numericValue)
        {
          data["price"] = parseFloat(((($(this).attr("data-price")/100)*numericValue)/totalPrice) - (byodPrice-numericValue)).toFixed(2) ;
          data["total_discount"] = parseFloat((($(this).attr("data-price")/100) - (($(this).attr("data-price")/100)*numericValue)/totalPrice) + (byodPrice-numericValue)).toFixed(2);
        }
        else
        {
          data["price"] = parseFloat((($(this).attr("data-price")/100)*numericValue)/totalPrice).toFixed(2);
          data["total_discount"] = parseFloat(($(this).attr("data-price")/100) - (($(this).attr("data-price")/100)*numericValue)/totalPrice).toFixed(2);
        }
        data["vendor"] = "GNC India";
        data["product_id"] = parseInt($(this).attr("data-product-id"));
        data["grams"] = "";
        data["sku"] = $(this).attr("data-variant-sku");
        data["fulfillable_quantity"] = "";
        data["fulfillment_service"] = "";
        data["taxable"] = false;
        data["fulfillment_service"] = "";
        data["discount_allocations"] = "";
        data["name"] = $(this).attr("data-product-name");
        data["price_set"] = "";
        data["properties"] = "";
        data["duties"] = "";
        data["currency_code"] = "INR";
        //console.log(data);
        dataType.push(data);
        idCheck = idCheck+1;
        $('#mainProductSKU').append('<input type="hidden" name="properties[_bundle_product'+idCheck+']" value="'+data["sku"]+'/'+data["price"]+'/'+data["quantity"]+'" />');

        
      });
      const newData = {
        items: [...dataType],
      };
      //console.log("data", newData);
      //$("#uniware_items").val(JSON.stringify(newData));
      return true; 
  });

}); //document.ready ends here

/* Shopify.getCart(function(cart) {
    var existingAttributes = cart.attributes;
    console.log("Your cart", cart);
    // Step 2: Remove the existing attribute with the old key / just assign empty value
    var oldKey = 'package-type product-id 8600755339557 variant-no-1 sku 8157552-002';
    if (existingAttributes[oldKey]) {
      console.log("old key exists");
      existingAttributes[oldKey] = '';
    }
   
    // Step 3: Add the attribute with the new key
    var newKey = 'new_attribute_key';
    existingAttributes[newKey] = 'new_attribute_value11';
   
 
    // Step 4: Update the cart attributes
    Shopify.updateCartAttributes(existingAttributes, function(updatedCart) {
      console.log('Cart attributes updated:', updatedCart.attributes);
    });
  });
  
  
        $.ajax({
        url: "/cart/update.js",
        method: "POST",
        data: { attributes: {uniware_ : JSON.stringify(newData) }},
        //data: { note: "" },
        success: function (result) {
          return fals;
        },
        error: function (jqxhr, status, exception) {
          console.log(exception);
        },
      });
  
  
  */

